<template>
  <DragDialog
    class="export-dialog"
    title="设置有效性"
    :width="480"
    :visible.sync="visible"
    :footerBtn="['cancel', 'submit']"
    :submit="submit"
    :cancel="cancel">
    <div class="item-box">
      <div class="label-box valid-date-box dialog-label">有效期：</div>
      <div class="common-datepicker-box">
        <el-date-picker
          class="date-picker-primary"
          v-model="validDate"
          type="date"
          size="mini"
          popper-class="datepicker-popper-box"
          :editable="false"
          :append-to-body="false"
          placeholder="选择日期"
          :picker-options="pickerOptions" />
      </div>
    </div>
    <div class="item-box">
      <div class="label-box dialog-label">密码：</div>
      <div class="content-box password">
        <el-radio-group
          class="radio-primary"
          v-model="passwordType">
          <div class="common-radio-box">
            <el-radio label="None">无</el-radio>
          </div>
          <div class="common-radio-box">
            <el-radio label="Random">系统随机生成密码</el-radio>
          </div>
          <div class="custom-password-box">
            <div class="common-radio-box">
              <el-radio label="Custom">{{ '' }}</el-radio>
            </div>
            <div class="common-input-box">
              <el-input
                class="input-primary"
                :disabled="passwordType !== 'Custom'"
                size="mini"
                :type="mode === 'setValidity' ? '' : 'password'"
                v-model="password"
                :show-password="mode === 'setValidity' ? false : true"
                placeholder="请输入自定义密码" />
            </div>
          </div>
        </el-radio-group>
      </div>
    </div>
    <div
      class="item-box"
      v-if="isExportWmtsVisible()">
      <div class="label-box">WMTS地图服务：</div>
      <div class="content-box radio-group-box">
        <el-radio-group
          class="radio-primary"
          v-model="enableWmtsDownload">
          <div class="common-radio-box">
            <el-radio :label="false">在线访问</el-radio>
          </div>
          <div class="common-radio-box">
            <el-radio :label="true">下载离线地图</el-radio>
          </div>
        </el-radio-group>
      </div>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from '@/components/CustomDragDialog.vue'

export default {
  data() {
    return {
      validDate: '',
      passwordType: 'None',
      password: '',
      enableWmtsDownload: false,

      pickerOptions: {
        disabledDate: date => {
          let currTime = new Date()
          let todayTime = new Date(currTime.toDateString()).getTime()
          let dateTime = date.getTime()

          return dateTime < todayTime
        }
      }
    }
  },
  props: {
    visible: Boolean,
    mode: String,
    currExportInfo: Object,
    exportData: Function,
    updateValidityInfo: Function,
    closeExportDialog: Function,
    closeDialog: Function
  },
  components: {
    DragDialog
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        if (this.mode === 'setValidity') {
          this.initValidityInfo()
        }
      }
    },
    passwordType: function (newVal) {
      if (newVal !== 'Custom') {
        this.password = ''
      }
    }
  },
  methods: {
    initValidityInfo() {
      let { expirationTime, password } = this.currExportInfo
      this.validDate = new Date(expirationTime)
      if (password) {
        this.passwordType = 'Custom'
        this.password = password
      } else {
        this.passwordType = 'None'
      }
    },
    submit() {
      let validDate = undefined
      if (!this.validDate) {
        this.$message.warning('请选择有效期')
        return
      } else {
        validDate = this.formatDate(this.validDate)
      }

      if (this.passwordType === 'Custom') {
        const regExp = /^[A-Za-z0-9][A-Za-z0-9.!@$%*?&#+]{7}$/
        if (!regExp.test(this.password)) {
          // prettier-ignore
          this.$message.warning('密码需为8位字符, 仅支持大小写字母、数字、特殊字符(".","@","$","!","%","*","?","&","#")');
          return
        }
      }

      let useRandomPassword = this.passwordType === 'Random' ? true : false
      let params = {
        useRandomPassword,
        password: this.password,
        expirationTime: validDate
      }
      if (this.mode === 'setValidity') {
        this.updateValidityInfo(params).then(() => {
          this.cancel()
        })
      } else {
        params.enableWmtsDownload = this.enableWmtsDownload
        this.exportData(params).then(() => {
          this.clearForm()
          this.closeDialog()
          this.closeExportDialog()
        })
      }
    },
    isExportWmtsVisible() {
      let visible = true
      if (!window.isShowExportWmts) {
        visible = false
        return visible
      }

      if (this.mode !== 'exportScene') {
        visible = false
      }
      return visible
    },
    formatDate(dateTime) {
      // prettier-ignore
      const zeroHour = new Date(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate());

      // prettier-ignore
      let formatDateTime = zeroHour.getTime() + (24 + 8) * 60 * 60 * 1000 - 1000;
      formatDateTime = new Date(formatDateTime).toJSON()
      return formatDateTime
    },
    clearForm() {
      this.validDate = ''
      this.passwordType = 'None'
      this.password = ''
      this.enableWmtsDownload = false
    },
    cancel() {
      this.clearForm()
      this.closeDialog()
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.export-dialog {
  :deep(.dialog-box) {
    overflow: visible;
  }
}
.item-box {
  display: flex;
  margin: 15px 0px;
  color: var(--default-color);

  &:first-child {
    align-items: center;
    margin: 0px 0px;
  }

  .label-box {
    width: 76px;
    font-size: 14px;
    text-align: right;
  }

  .valid-date-box {
    &::before {
      content: '*';
      margin-right: 5px;
      color: var(--error-status-color);
    }
  }

  .content-box {
    margin-top: 3px;

    &.password {
      .radio-primary {
        flex-direction: column;
      }
    }

    .common-radio-box {
      width: 150px;

      &:not(:first-child) {
        margin-top: 10px;
      }

      /deep/ .el-radio__input.is-checked + .el-radio__label {
        color: var(--default-color);
      }

      /deep/ .el-radio input[aria-hidden='true'] {
        display: none !important;
      }

      /deep/
        .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled)
        .el-radio__inner {
        box-shadow: none !important;
      }
    }

    .custom-password-box {
      display: flex;
      align-items: center;
      margin-top: 10px;

      .common-radio-box {
        width: unset;
        margin-right: 0;
      }

      .common-input-box {
        margin-top: 5px;

        /deep/ .el-input__inner:-webkit-autofill,
        .el-input__inner:-webkit-autofill:hover,
        .el-input__inner:-webkit-autofill:focus,
        .el-input__inner:-webkit-autofill:active {
          -webkit-transition-delay: 99999s;
          -webkit-transition: color 99999s ease-out,
            background-color 99999s ease-out;
        }
      }
    }
  }

  .radio-group-box {
    .el-radio-group {
      display: flex;
      align-items: center;
    }
  }
}
</style>
